import React from 'react';
import { 
    TextInput, 
    TouchableOpacity, 
    View, 
    Text, 
    StyleSheet, 
    Linking, 
    Alert 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import * as _ from 'lodash';
import { NotificationContext } from '../../contexts/notification/Store';
import moment from 'moment';
import { useNavigation } from '@react-navigation/native';
import Config from '../../constants/Config';
import { AnalyticsService } from '../../constants/Analytics';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import StyledButton from '../StyledButton';
import http from '../../utils/http';

const analytics = new AnalyticsService

const VisitModal = (props) => {
    const [nState, nDispatch] = React.useContext(NotificationContext);
    const navigation = useNavigation();

    const gotoHelp = () => {
        props.hideModal()
        navigation.navigate('Help')
    }

    if (!_.has(props, 'promotion') && !_.has(props, 'buyerData')) {
        return null
    }
    // console.log(props.data)
    const type = props.data.type

    const [address, setAddress] = React.useState(props.buyerData.address);
    const [isEditingAddress, setEditingAddress] = React.useState(false);
    const [isSubmitting, setSubmitting] = React.useState(false);
    const [isSubmitSuccess, setSubmitSuccess] = React.useState(false);

    const clickAreaRef = React.useRef()

    const toggleEditing = () => {
        setEditingAddress(!isEditingAddress)
    }

    const requestVisit = () => {
        // add to notification stack
        // let notification = Object.assign({}, { _id: moment().unix(), expiry: moment().add(30, 'seconds'), promotion: props.promotion, buyer: props.buyerData._id })
        // nDispatch({ type: 'ADD', payload: notification })
        // return

        setSubmitting(true)

        let formData = new FormData()
        formData.append('address', address)
        formData.append('status', 'requested')
        formData.append('meta', props.buyerData.phone)
        formData.append('buyer_id', props.buyerData._id)
        formData.append('promotion_id', props.promotion._id)

        // console.log(formData)
        http.post('visit/create', formData, props.token)
            .then(res => {
                if (res.code === 200) {
                    console.log('visit requested', res)
                    // add to notification stack
                    let notification = Object.assign({}, {
                        _id: res.data,
                        expiry: moment().add(Config.notificationDelay.duration, Config.notificationDelay.type),
                        promotion: props.promotion,
                        buyer: props.buyerData._id
                    })
                    nDispatch({ type: 'ADD', payload: notification })
                    setSubmitSuccess(true)

                    // log visit event
                    analytics.logEvent('Started Visit Me', props.buyerData, {
                        visit_id: res.data,
                        promotion_id: props.promotion._id,
                        promotion_title: props.promotion.title
                    });

                } else {
                    setSubmitting(false)
                    Alert.alert('', res.message)
                    console.log(res)
                }
            })
            .catch(err => {
                console.log(err)
                setSubmitting(false)
            })
    }
    const requestCall = () => {
        analytics.logEvent('Clicked Call Wholesaler', props.buyerData, {
            promotion_id: props.promotion._id,
            promotion_title: props.promotion.title,
        });
        Linking.openURL('tel:' + props.data.value)
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                if (!isSubmitting) {
                    hideModal()
                }
            }
        }
    }

    return (
        <>
            {
                !_.has(props, 'promotion') && !_.has(props, 'buyerData')
                    ? null
                    : <Modal
                        presentationStyle='overFullScreen'
                        animationType="slide"
                        transparent={true}
                        visible={props.isActive}
                        onRequestClose={() => {
                            // console.log('modal closed')
                        }}>
                        <View
                            ref={clickAreaRef}
                            onStartShouldSetResponder={handleClickOutside}
                            style={styles.overlay}
                        >
                            <View style={styles.container}>

                                <TouchableOpacity
                                    style={styles.closeButton}
                                    onPress={() => {
                                        props.hideModal()
                                    }} >
                                    <Text style={styles.closeButtonText}>Close</Text>
                                    <Icon name='md-close' size={24} color='#FFFFFF' />
                                </TouchableOpacity>

                                {!isSubmitSuccess ?
                                    <View style={styles.card}>
                                        {type === 'visit' ?
                                            <Text style={styles.cardHeader}>Confirm Visit Request</Text> :
                                            <Text style={styles.cardHeader}>Confirm Call</Text>
                                        }

                                        {type === 'visit' ?
                                            <Text style={styles.cardBody}>Please confirm you want a sales rep to visit you for this promo: <Text style={{ fontWeight: 'bold' }}>{props.promotion.title}</Text></Text> :
                                            <Text style={styles.cardBody}>Please confirm you want to call a sales rep for this promo: <Text style={{ fontWeight: 'bold' }}>{props.promotion.title}</Text></Text>
                                        }

                                        {type === 'visit' && <View>
                                            <Text style={styles.inputLabel}>Your Address</Text>
                                            {isEditingAddress ?
                                                <TextInput style={styles.textInput} value={address} onChangeText={text => setAddress(text)} /> :
                                                <Text style={styles.textInputDisplay}>{address}</Text>
                                            }
                                            <TouchableOpacity
                                                style={styles.toggleButton}
                                                activeOpacity={0.6}
                                                onPress={toggleEditing}
                                            >
                                                <Text style={styles.toggleButtonText}>{isEditingAddress ? 'Set Address' : 'Change Address'}</Text>
                                            </TouchableOpacity>
                                        </View>}

                                        {
                                            type === 'visit'
                                                ? <StyledButton
                                                    label="Yes, Visit me"
                                                    action={requestVisit}
                                                    disabled={isEditingAddress || address === '' || !address}
                                                    style={{
                                                        opacity: (isEditingAddress || address === '' || !address) ? 0.6 : 1,
                                                        marginBottom: 10
                                                    }}
                                                />
                                                : <StyledButton
                                                    label="Call Wholesaler"
                                                    action={requestCall}
                                                />
                                        }

                                        <TouchableOpacity style={styles.faqButton} onPress={gotoHelp}>
                                            <Text style={styles.faqButtonText}>I don't understand this</Text>
                                        </TouchableOpacity>
                                    </View> :

                                    <View style={[styles.card, { alignItems: 'center' }]}>

                                        <Icon name='ios-checkmark-circle' size={57.75} color='#00A879' style={{ margin: 9.63 }} />
                                        <Text style={[styles.cardBody, { textAlign: 'center', width: 238 }]}>Your visit request has been sent. A sales rep will visit you in the coming days.</Text>
                                        <Text style={[styles.cardBody, { textAlign: 'center', width: 238, marginTop: 20, color: '#9DA5B0' }]}>Enjoy the rest of your day.</Text>

                                        <StyledButton
                                            style={{
                                                marginTop: 30
                                            }}
                                            action={props.hideModal}
                                            label="See Other Promotions"
                                        />

                                    </View>
                                }
                            </View>
                        </View>
                    </Modal>
            }
        </>

    )
}

export default VisitModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    container: {
        width: '100%',
        paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end'
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center'
    },
    card: {
        borderRadius: 10,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16
    },
    cardHeader: {
        width: 157,
        color: '#171C34',
        ...FontStyles.size16,
        ...FontStyles.lh20,
        ...FontStyles.bold,
        marginBottom: 16,
    },
    cardBody: {
        width: 288,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        marginBottom: 20,
    },
    inputLabel: {
        width: 85,
        color: Colors.shades._7,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        marginBottom: 7,
    },
    textInput: {
        // height: 20,
        width: '100%',
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        marginBottom: 8,
        paddingHorizontal: 4,
        borderRadius: 2,
        backgroundColor: 'rgba(0,0,0,0.06)'
    },
    textInputDisplay: {
        // height: 20,
        width: '100%',
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        marginBottom: 8,
    },
    toggleButton: {
        paddingVertical: 2,
        marginBottom: 31
    },
    toggleButtonText: {
        // height: 15,
        width: 96,
        color: '#3B54EC',
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
    },
    faqButton: {
        height: 36,
        width: '100%',
        borderRadius: 4,
        // backgroundColor: '#3B54EC',
    },
    faqButtonText: {
        marginVertical: 10,
        height: 16,
        color: Colors.shades._7,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
    },
})